// removed by extract-text-webpack-plugin
module.exports = {"link":"R8zaM","root":"_25ygu","itemName":"_2WWZB","itemNameLink":"_2Pk9X","authorAndCategory":"JHf2a"};